import * as jwtDecode from "jwt-decode";

class Decoder {
  public decode(token: any): any {
    const decoded = jwtDecode(token);
    const date: any = new Date().getTime();
    const expiration = new Date(decoded.exp * 1000).getTime();
    let isExpired: boolean = false;

    if ((expiration - date) < 0) {
      isExpired = true;
    }

    return {
      ...decoded,
      isExpired: isExpired
    };
  }

}

export default new Decoder();
